// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type ApplyConfigurationCard_ReadyPlanConfigLike_CheckoutConfig_Fragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], exteriorOptionNames: Array<string>, interiorOptionNames: Array<string>, aduProductOffering?: { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined, aduAggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined, readyPlan?:
    | { __typename?: 'ReadyPlan', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'PlanPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'DesignPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'ProductOffering', id: string, name: string, code?: string | null | undefined }
   | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined };

export type ApplyConfigurationCard_ReadyPlanConfigLike_ProductOfferingConfig_Fragment = { __typename?: 'ProductOfferingConfig', id: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], exteriorOptionNames: Array<string>, interiorOptionNames: Array<string>, pocProductOffering: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined }, readyPlan:
    | { __typename?: 'ReadyPlan', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'PlanPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'DesignPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'ProductOffering', id: string, name: string, code?: string | null | undefined }
  , productOffering: { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } };

export type ApplyConfigurationCard_ReadyPlanConfigLike_ProjectReadyPlanConfig_Fragment = { __typename?: 'ProjectReadyPlanConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], exteriorOptionNames: Array<string>, interiorOptionNames: Array<string>, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined, readyPlan?:
    | { __typename?: 'ReadyPlan', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'PlanPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'DesignPackage', id: string, name: string, code?: string | null | undefined }
    | { __typename?: 'ProductOffering', id: string, name: string, code?: string | null | undefined }
   | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined };

export type ApplyConfigurationCard_ReadyPlanConfigLikeFragment =
  | ApplyConfigurationCard_ReadyPlanConfigLike_CheckoutConfig_Fragment
  | ApplyConfigurationCard_ReadyPlanConfigLike_ProductOfferingConfig_Fragment
  | ApplyConfigurationCard_ReadyPlanConfigLike_ProjectReadyPlanConfig_Fragment
;

export type ApplyConfigurationCard_AggregateVersionFragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string };

export type ApplyConfigurationCard_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined };

export const ApplyConfigurationCard_ProductOfferingFragmentDoc = gql`
    fragment ApplyConfigurationCard_ProductOffering on ProductOffering {
  id
  coverAsset {
    id
    previewUrl(resizing: {width: 321, region: FULL})
  }
}
    `;
export const ApplyConfigurationCard_AggregateVersionFragmentDoc = gql`
    fragment ApplyConfigurationCard_AggregateVersion on ReadyPlanAggregateVersion {
  id
  displayVersion
}
    `;
export const ApplyConfigurationCard_ReadyPlanConfigLikeFragmentDoc = gql`
    fragment ApplyConfigurationCard_ReadyPlanConfigLike on ReadyPlanConfigLike {
  id
  name
  updatedAt
  readyPlan {
    id
    name
    code
  }
  exteriorOptionNames
  interiorOptionNames
  productOffering {
    ...ApplyConfigurationCard_ProductOffering
  }
  ... on CheckoutConfig {
    id
    aduProductOffering {
      ...ApplyConfigurationCard_ProductOffering
    }
    aggregateVersion {
      ...ApplyConfigurationCard_AggregateVersion
    }
    aduAggregateVersion {
      ...ApplyConfigurationCard_AggregateVersion
    }
  }
  ... on ProjectReadyPlanConfig {
    id
    aggregateVersion {
      ...ApplyConfigurationCard_AggregateVersion
    }
  }
  ... on ProductOfferingConfig {
    id
    pocProductOffering: productOffering {
      ...ApplyConfigurationCard_ProductOffering
      aggregateCheckout {
        ...ApplyConfigurationCard_AggregateVersion
      }
    }
  }
}
    ${ApplyConfigurationCard_ProductOfferingFragmentDoc}
${ApplyConfigurationCard_AggregateVersionFragmentDoc}`;